import React from 'react';

// Small inline-SVG icon set (replaces react-bootstrap-icons — de-Bootstrap). Icons
// inherit color via `currentColor` and size via width/height props (default 1em).

interface IconProps {
    size?: number | string;
    className?: string;
    title?: string;
}

const base = (size: IconProps['size']) => ({
    width: size ?? '1em',
    height: size ?? '1em',
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.6,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
    'aria-hidden': true,
    focusable: false,
});

export const MenuIcon = ({ size, className }: IconProps) => (
    <svg {...base(size)} className={className}>
        <line x1="3" y1="6" x2="21" y2="6" />
        <line x1="3" y1="12" x2="21" y2="12" />
        <line x1="3" y1="18" x2="21" y2="18" />
    </svg>
);

export const CloseIcon = ({ size, className }: IconProps) => (
    <svg {...base(size)} className={className}>
        <line x1="5" y1="5" x2="19" y2="19" />
        <line x1="19" y1="5" x2="5" y2="19" />
    </svg>
);

export const ChevronRightIcon = ({ size, className }: IconProps) => (
    <svg {...base(size)} className={className}>
        <polyline points="9 6 15 12 9 18" />
    </svg>
);

export const ArrowLeftIcon = ({ size, className }: IconProps) => (
    <svg {...base(size)} className={className}>
        <line x1="19" y1="12" x2="5" y2="12" />
        <polyline points="11 6 5 12 11 18" />
    </svg>
);

export const ArrowRightIcon = ({ size, className }: IconProps) => (
    <svg {...base(size)} className={className}>
        <line x1="5" y1="12" x2="19" y2="12" />
        <polyline points="13 6 19 12 13 18" />
    </svg>
);

export const InstagramIcon = ({ size, className }: IconProps) => (
    <svg {...base(size)} className={className}>
        <rect x="3" y="3" width="18" height="18" rx="5" />
        <circle cx="12" cy="12" r="4" />
        <circle cx="17.2" cy="6.8" r="1" fill="currentColor" stroke="none" />
    </svg>
);
